<template>
  <div>
    <top-bar heading="Messages" :buttons="buttons"></top-bar>
    <div class="container-fluid p-0 p-md-3">
      <b-card header="Messages">
        <b-card-body>
          <vue-good-table
                  :columns="columns"
                  :rows="messages"
                  :pagination-options="{
                  enabled: true,
                  mode: 'records',
                  perPage: 10,
                  position: 'bottom',
                  perPageDropdown: [10, 25, 50, 100],
                  dropdownAllowAll: false,
                  setCurrentPage: 1,
                  nextLabel: 'next',
                  prevLabel: 'prev',
                  rowsPerPageLabel: 'Rows per page',
                  ofLabel: 'of',
                  pageLabel: 'page', // for 'pages' mode
                  allLabel: 'All',
                }"
                  :isLoading="loading"
          >
            <template slot="table-row" slot-scope="props">
              <span v-if="props.column.field === 'participants'">
                {{ props.row.participants.map(u => u.name_full).join(', ') | truncate }}
              </span>
              <span v-else-if="props.column.field === 'is_read'">
                <span class="badge badge-success p-1" v-if="props.row.is_read"><i class="fas fa-check"></i> Read</span>
                <span class="badge badge-danger p-1" v-if="!props.row.is_read"><i class="fas fa-times"></i> Unread</span>
              </span>
              <span v-else-if="props.column.field === 'updated_at'">
                {{ props.row.updated_at | moment('calendar') }}
              </span>
              <span v-else-if="props.column.field === 'action'">
                <router-link :to="'/messages/' + props.row.id" class="btn" :class="{'btn-primary':props.row.is_read, 'btn-danger': !props.row.is_read}">
                  <font-awesome-icon icon="eye"></font-awesome-icon>
                </router-link>
              </span>
              <span v-else>
                {{props.formattedRow[props.column.field]}}
              </span>
            </template>
          </vue-good-table>
        </b-card-body>
      </b-card>
    </div>
  </div>
</template>

<script>
import CreateMessageModal from '../../components/CreateMessageModal';

export default {
  name: 'Messages',
  data () {
    return {
      messages: [],
      loading: true,
      columns: [
        {
          label: 'Date',
          field: 'updated_at'
        },
        {
          label: 'Subject',
          field: 'subject'
        },
        {
          label: 'Participants',
          field: 'participants'
        },
        {
          label: 'Action',
          field: 'action'
        }
      ],
      buttons: [
        {
          label: 'New Message',
          click: () => {
            this.$modal.show(CreateMessageModal, {}, {width: '75%', resizable: true, adaptive: true, height: 'auto'}, {'after-close': () => { this.getMessages(); }});
          }
        }
      ]
    };
  },
  methods: {
    getMessages () {
      this.loading = true;
      this.axios.get('/messages').then(rsp => {
        this.messages = rsp.data;
        this.loading = false;
      });
    }
  },
  mounted () {
    this.getMessages();
  },
  metaInfo: {
    title: 'Messages'
  }
};
</script>
